
var CBaseNonPersistentModel = Backbone.Model.extend({

    areAlphaNumericValues: function(texts)
    {
        var self = this;
        var strInvalidMatch = _.find(texts, function(item){
            return !self.isAlphanumeric(item);
        });
        return (typeof strInvalidMatch === 'undefined');
    },

    isAlphanumeric: function(text)
    {
        var re = /^[a-z0-9-_\såÅøØæÆ]+$/i;

        if (!re.test(text))
        {
            return  false
        }
        return true;
    }

});